import { ISitePage } from 'core-components/sitebuilder/models/ISitePage'
import { StorageApi } from 'src/core/classes/services/api/StorageApi'
import { KEY_SITEPAGES_LAYOUT_DATA } from 'src/core/components/app/loaders/constants/sitePage'

export const saveSitePageToCache = async (sitePage: ISitePage) => {
  const dataToSave = { ...(StorageApi.get(KEY_SITEPAGES_LAYOUT_DATA) || {}) }
  dataToSave[sitePage.id] = {
    layout: sitePage.layoutUser,
    layoutSettings: sitePage.layoutUserSettings,
  }
  await StorageApi.set(KEY_SITEPAGES_LAYOUT_DATA, structuredClone(dataToSave))
}
